/* eslint-disable max-len */
import { buildChartTheme, darkTheme, lightTheme } from '@visx/xychart';
import Path from '@leverege/path';
import { camelCaseToTitleCase } from '@leverege/string-util';
export function buildCustomChartTheme(dark = true) {
  const theme = buildChartTheme({
    ...(dark ? darkTheme : lightTheme)
  });
  const colors = [];
  for (let i = 1; i <= 7; i++) {
    colors.push(`var( --color-graphSeries${i}, ${theme.colors[i - 1]})`);
  }
  theme.colors = colors;
  theme.backgroundColor = `var( --color-graphBackground, ${theme.backgroundColor || '#000000'} )`;
  theme.axisStyles.x.bottom.axisLabel.fill = `var( --color-graphXAxisLabel, ${theme.axisStyles.x.bottom.axisLabel.fill || '#ffffff'} )`;
  theme.axisStyles.x.top.axisLabel.fill = `var( --color-graphXAxisLabel, ${theme.axisStyles.x.top.axisLabel.fill || '#ffffff'} )`;
  theme.axisStyles.y.right.axisLabel.fill = `var( --color-graphYAxisLabel, ${theme.axisStyles.y.right.axisLabel.fill || '#ffffff'} )`;
  theme.axisStyles.y.left.axisLabel.fill = `var( --color-graphYAxisLabel, ${theme.axisStyles.y.left.axisLabel.fill || '#ffffff'} )`;
  theme.axisStyles.x.bottom.tickLabel.fill = `var( --color-graphXTickLabel, ${theme.axisStyles.x.bottom.tickLabel.fill || '#ffffff'} )`;
  theme.axisStyles.x.top.tickLabel.fill = `var( --color-graphXTickLabel, ${theme.axisStyles.x.top.tickLabel.fill || '#ffffff'} )`;
  theme.axisStyles.y.right.tickLabel.fill = `var( --color-graphYTickLabel, ${theme.axisStyles.y.right.tickLabel.fill || '#ffffff'} )`;
  theme.axisStyles.y.left.tickLabel.fill = `var( --color-graphYTickLabel, ${theme.axisStyles.y.left.tickLabel.fill || '#ffffff'} )`;
  theme.axisStyles.x.bottom.axisLine.stroke = `var( --color-graphXAxisLine, ${theme.axisStyles.x.bottom.axisLine.stroke || '#ffffff'} )`;
  theme.axisStyles.x.top.axisLine.stroke = `var( --color-graphXAxisLine, ${theme.axisStyles.x.top.axisLine.stroke || '#ffffff'} )`;
  theme.axisStyles.y.right.axisLine.stroke = `var( --color-graphYAxisLine, ${theme.axisStyles.y.right.axisLine.stroke || '#ffffff'} )`;
  theme.axisStyles.y.left.axisLine.stroke = `var( --color-graphYAxisLine, ${theme.axisStyles.y.left.axisLine.stroke || '#ffffff'} )`;
  theme.threshold = {
    stroke: 'var( --color-graphThreshold, --color-danger700 )'
  };
  return theme;
}
export function buildCustomPieChartTheme(dark = true) {
  const theme = buildChartTheme({
    ...(dark ? darkTheme : lightTheme)
  });
  const colors = [];
  for (let i = 1; i <= 10; i++) {
    colors.push(`var( --color-graphSeries${i}, ${theme.colors[i - 1]})`);
  }
  theme.colors = colors;
  theme.backgroundColor = `var( --color-graphBackground, ${theme.backgroundColor || '#000000'} )`;
  return theme;
}
export function seriesDataIsEmpty(data) {
  // if ( data == null ) {
  //   return true
  // }

  if (Array.isArray(data) && data.length > 0) {
    return false;
  }
  return true;
  // const entries = Object.entries( data )

  // if ( entries.length === 0 ) {
  //   return true
  // }

  // return !entries.some( ( [ key, value ] ) => value.length > 0 )
}
export function getTypeForSeries(seriesObj) {
  const seriesType = seriesObj?.type;
  if (!seriesType) {
    return null;
  }
  return seriesType.replace('graph.series.', '');
}
const TYPE_ICONS = {
  area: 'https://molten-ui-assets.storage.googleapis.com/graphs/area.svg',
  areaStack: 'https://molten-ui-assets.storage.googleapis.com/graphs/areaStack.svg',
  bar: 'https://molten-ui-assets.storage.googleapis.com/graphs/bar.svg',
  barGroup: 'https://molten-ui-assets.storage.googleapis.com/graphs/barGroup.svg',
  barStack: 'https://molten-ui-assets.storage.googleapis.com/graphs/barStack.svg',
  glyphLine: 'https://molten-ui-assets.storage.googleapis.com/graphs/glyphLine.svg',
  line: 'https://molten-ui-assets.storage.googleapis.com/graphs/line.svg',
  pie: 'https://molten-ui-assets.storage.googleapis.com/graphs/pie.svg'
};
export function getDefaultIconForSeriesType(type) {
  return TYPE_ICONS[type] || 'https://molten-ui-assets.storage.googleapis.com/graphs/line.svg';
}
export function getAggTitle(query, sourceObjectType) {
  switch (query.type) {
    case 'aggregation.geoDistance':
      return 'Distances';
    case 'aggregation.range':
      {
        const field = Path(query.field).last();
        return `${camelCaseToTitleCase(field)} Ranges`;
      }
    case 'aggregation.histogram':
    case 'aggregation.stats':
    case 'aggregation.terms':
      {
        const field = Path(query.field).last();
        return `${camelCaseToTitleCase(field)}s`;
      }
    case 'aggregation.filter':
    case 'aggregation.filters':
      {
        return `${camelCaseToTitleCase(sourceObjectType)}s`;
      }
    default:
      return null;
  }
}